import React from "react"

function DownloadCard(props) {
    const firstDownloadText = "These are the intial investigation files, they will be needed throughout the game."
    const returnDownloadText = "Lost your initial investigation files? You can download them again here."
    
    const text = props.playerStage > 0 ?  returnDownloadText : firstDownloadText
    
    return (
        <div>
            <div id="downloadModule" className="homeCard">
                <h1 className="greenTab">Download The Investigation Files</h1>
                <h3>{text}</h3>
                <button className="standardButton" onClick={props.handleDownload}>Download</button>
            </div>
            
            <div className="doorFrame homeDoor">                        
                <div className="doorHandle"></div>
                <div className="doorWindow">
                    <h5>Larry Maxwell</h5>
                    <h6>Private Investigator</h6>
                </div>
            </div>
        </div>
    )
}

export default DownloadCard